module.exports = __webpack_public_path__ + "static/media/dollar_menu_active.f2bf1665.svg";